import { Typography } from "@mui/material";
import type React from "react";
import { Suspense } from "react";
import useDetail from "../../../../hooks/useDetail.ts";
import { PriceType } from "../../../../api/rest/generated/aPIForPublicPartOfApplicationInzerceNemovitéhoMajetku.schemas.ts";

const PriceComponent: React.FC<{ id: number; }> = ({ id }) => {
	const detail = useDetail(id);

	const showPrice = detail.data.showPrice;
	const price = detail.data.price;
	const priceType = detail.data.priceType === PriceType.AskingPrice ? "Vyvolávací cena" : "Cena";

	if (!showPrice) {
		return null;
	}

	if (!price) {
		return null;
	}

	const formattedPrice = Intl.NumberFormat("cs-CZ", { maximumFractionDigits: 2, currency: "CZK" }).format(price);

	return (
		<Typography fontWeight="bolder" sx={{ color: "info.main" }} variant="subtitle1" component="div">
			{`${priceType}: ${formattedPrice} Kč`}
		</Typography>
	);
};

export const Price: React.FC<{ id: number; }> = ({ id }) => {
	return (
		<Suspense>
			<PriceComponent id={id} />
		</Suspense>
	);
};